<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
    <v-btn block color="primary">
      {{ $t('related.update_schema') }}
    </v-btn>
  </slot>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('related.update_schema') }} - {{schema.name}}
    </v-card-title>
    <v-container>
      <v-form ref="form" v-model="valid" v-on:submit="save">
        <v-flex xs8>
          <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
        </v-flex>

        <v-btn type="submit">
          {{ $t('archive.filter.save') }}
        </v-btn>
      </v-form>
    </v-container>
  </v-card>
</v-dialog>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  props: ["schema"],
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => (!!v && (v.length <= 100 && v.length > 1)) || this.$t('validator.wrong_length')
      ],
      show: false,
      valid: false
    }
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.patch('related/schema/' + this.schema.id, this.getPayload())
          .then(() => {
            this.schema.name = this.name
            this.show = false;
            this.showMessage(this.$t('related.schema_updated'), "success")
          }).catch(() => {
            this.showMessage(this.$t('related.update_error'), "danger")
          })
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
  created() {
    this.name = this.schema.name
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
</style>
